<script>
export default {
  name: 'TitleIntro',
  props: {
    delay: {
      type: Number,
      default: null,
    },
  },

  data () {
    return {
      isActive: false,
    }
  },

  mounted () {
    if (this.delay > 0) {
      setTimeout(() => {
        this.isActive = true
      }, this.delay)
    } else {
      this.isActive = true
    }
  },

  // eslint-disable-next-line no-unused-vars
  render (h) {
    const classes = {
      'zv-intro': true,
      'is-disabled': !this.isActive,
      'is-active': this.isActive,
    }

    return (
      <div class={classes}>
        {this.$slots.default}
      </div>
    )
  },
}
</script>
